var render, staticRenderFns
import script from "./SwaggerDocManage.vue?vue&type=script&lang=js&"
export * from "./SwaggerDocManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00401432",
  null
  
)

export default component.exports